// extracted by mini-css-extract-plugin
export default {"error":"ErrorBoundary-module__error___78dKl","stack":"ErrorBoundary-module__stack___lWjxz"};